<template>
  <q-input
    style="min-width: 300px"
    color="primary"
    :value="value"
    debounce="500"
    label="Search"
    dense
    outlined
    @input="$emit('input', { value, search: $event })"
  >
    <template v-slot:prepend>
      <q-icon name="search" />
    </template>
  </q-input>
</template>
<script>
export default {
  name: 'AppQuotesSearch',
  props: {
    value: String,
    context: String
  }
};
</script>
